import React, { useState } from 'react';
import TierHeader from './TierHeader';
import TierLegends from './TierLegends';
import { Collapse } from 'reactstrap';
import { Framework, Tier1 } from 'src/shared/types/src';
import TierNode from './TierNode';
import _ from 'lodash';

const TierOne = ({ _framework, expand }: { _framework: Framework, expand: boolean }) => {
  const [isVisible, setIsVisible] = useState(expand);
  const assessments = _framework.assessments as Tier1;
  
  return (
    <div className='framework-tier-wrap'>
      <TierHeader tierTitle={_framework.name} onClick={() => setIsVisible(!isVisible)} isVisible={isVisible} />
        <Collapse isOpen={isVisible}> 
          <div className='mg-t-10'>
          <TierLegends assessmentLevels={_framework.assessmentLevel} />
            <div className='mg-t-5'>
              { assessments?.statements?.map((statement, index) => 
                <TierNode content={statement.name} label={statement.label} key={index} isStatement={true} borderColor={statement.color} iconType={statement.iconType}/>
              )}
            </div>
          </div>
        </Collapse>
    </div>
  );
};

export default TierOne;
